module.exports = __webpack_public_path__ + "img/solution-channer-rg.101090f5.png";